import useOnBoardSchedule from "../../../../hooks/useOnBoardSchedule";
import useViewer from "../../../../hooks/useViewer";
import { useMemo } from "react";
import { Event, TimelineEventTrack } from "../../../../../CommonComponents/timeline/Timeline";
import ScheduleOverlay from "../../../../../CommonComponents/overlays/ScheduleOverlay";
import { event_status_state } from "./Svgs";
import { ContactTaskSvg, NotContactTaskSvg } from "../../../../../CommonComponents/svgs/Svgs";

const OnboardContact = () => {

    const { current_simulation_time } = useViewer()
    const { timelineScheduleData } = useOnBoardSchedule()

    const currentTime = useMemo(() => current_simulation_time / 1000, [current_simulation_time])

    const get_contact_status = (start_time: number, end_time: number) => {
        if (currentTime >= start_time && currentTime <= end_time) {
            return 'ongoing'
        } else if (currentTime < start_time) {
            return 'upcoming'
        } else if (currentTime > end_time) {
            return 'completed'
        } else {
            return 'not_scheduled'
        }
    }

    return (
        <TimelineEventTrack>
            {timelineScheduleData.map((event: any, index) => {
                const { startTime, endTime, taskName } = event
                const contactType = event?.type
                const icon = contactType === 'Contact' ? <ContactTaskSvg /> : <NotContactTaskSvg />
                const status = get_contact_status(startTime, endTime)
                const statusIcon = event_status_state[status]?.svg
                const uniqueid = `event-${index}-${startTime}-${endTime}-${taskName}`
                if (event?.status === 'Conflict') return null
                return (
                    <Event
                        key={uniqueid}
                        icon={icon}
                        statusIcon={statusIcon}
                        endTime={endTime}
                        eventName={taskName}
                        startTime={startTime}
                        allEvents={timelineScheduleData}
                        eventType={status}
                        className={status}
                        overlay={ScheduleOverlay}
                    />
                )
            })}
        </TimelineEventTrack>
    )
}
export default OnboardContact